/* global gtag */
export default {
  init() {
    // JavaScript to be fired on the home page
	

/***** ADD WAYPOINTS *****/

	$('.mm-article-section').waypoint(function () {
		$('.mm-photo-animated').addClass('mm_bind');
		this.destroy();
	}, {
		offset: '75%'
	});

	$('.nasi-klienci').waypoint(function () {
		$('.nasi-klienci').addClass('mm_bind-nk');
		this.destroy();
	}, {
		offset: '75%'
	});

	$('.slides-frame').waypoint(function () {
		$('.slides .col-md-3').addClass('mm_bind-nk');
		this.destroy();
	}, {
		offset: '75%'
	});

	$('.slides-frame').waypoint(function () {
		$('.slides').addClass('active-slide');
		this.destroy();
	}, {
		offset: '75%'
	});

	$('.wrapper').hover(function () {
		var scaleBg = $(this).find('.slide-first');
		scaleBg.addClass('zero-tranition-delay');
	}, function () {
		var scaleBg = $(this).find('.slide-first');
		scaleBg.addClass('zero-tranition-delay');
	});

/***** MAIN SLIDER *****/

	$('.mm-social-feed .mm-carousel').css({left: $('.mm-projects').offset().left-8});
	
	var $mainSlider = $('.mm-main-slider'),
		$mainSliderNav = $('.mm-main-slider-nav'),
		$slides = $('.mm-slides>div'),
		allSlides = $('.mm-slides>div').length,
        duringChange = false,
		runNextSlide = function(){
			var currentSlide = $('.mm-slides>div.mm-animated-header--in', $mainSlider).index();
            
            duringChange = true;
            $slides.eq(currentSlide).removeClass('mm-animated-header--in').addClass('mm-animated-header--out');
            
			currentSlide++;
			
			if(currentSlide===allSlides) {
				currentSlide = 0;
			}
            
			window.setTimeout(function(){
                $slides.removeClass('mm-animated-header--out').eq( currentSlide ).addClass('mm-animated-header--in');
                duringChange = false;
            }, 1300);
            
			
			// console.log($('li', $mainSliderNav));
			$('li', $mainSliderNav).removeClass('active').eq( currentSlide ).addClass('active');
			
		},
		autoChangeInterval = 0;
	
	$('li', $mainSliderNav).on('click', function() {

        var $this = $(this);
        
        if(duringChange) {
            return;
        }

		duringChange = true;
		clearInterval(autoChangeInterval);
        
        var currentSlide = $('.mm-slides>div.mm-animated-header--in', $mainSlider).index();
        $slides.eq(currentSlide).removeClass('mm-animated-header--in').addClass('mm-animated-header--out');
        
        $('li', $mainSliderNav).removeClass('active');
        
        window.setTimeout(function(){
                
            $slides.removeClass('mm-animated-header--out').eq( $this.index()).addClass('mm-animated-header--in');
            $this.addClass('active');

            duringChange = false;

            autoChangeInterval = setInterval(function(){
                runNextSlide.call();
            }, 6000);
        }, 1300);        
        

	});
	
	window.setTimeout(function(){
		$('.mm-main-slider .mm-slides>div').eq(0).addClass('mm-animated-header--in');
	}, 600);
	
	autoChangeInterval = setInterval(function(){
		runNextSlide.call();
	}, 6000);


/***** VIDEO BG PLAY *****/

    for(var i=1; i<=4; i++) {
		$(".video-box-"+i).hover( function() {
            
            var i = $(this).index()+1;
            
            $('.video-'+i+' video').get(0).play();
            $('.video-'+i).css('z-index', -1).siblings().css('z-index', -2);
        }, function() {
            $('video').get(0).pause(); 
        } );
        
    }


/***** ADD CUSTOM CLASS TO VIDEO BG SECTION *****/

	$('.grid-item:nth-child(1)').hover(function(){
		$(this).parent().addClass('hover-1');
	}, function(){
		$(this).parent().removeClass('hover-1');
	});

	$('.grid-item:nth-child(4)').hover(function(){
		$(this).parent().addClass('hover-4');
	}, function(){
		$(this).parent().removeClass('hover-4');
	});

/***** SCROLL BUTTON *****/

	$('.mm-scroll-down').on('click', function(){
		$('html, body').delay(100).animate({
			scrollTop: $('.owl-theme.owl-carousel-3-items').offset().top
		}, 700 );
	});

/***** VERTICAL SLIDER *****/


$(".vertical-carousel").owlCarousel({
  loop: true,
  autoplay: true,
  items: 1,
  nav: false,
  mouseDrag: false,
  touchDrag: false,
  autoplayHoverPause: false,
  animateOut: 'slideOutUp',
  animateIn: 'slideInUp'
});

$(".mobile-clients-carousel").owlCarousel({
  loop: true,
  autoplay: true,
  items: 1,
  nav: false,
  mouseDrag: true,
  touchDrag: true,
  autoplayHoverPause: false
});


$('.client-logo-container').not('.mobile-clients-carousel .client-logo-container').each(function(){
   
    var random = Math.floor(Math.random()*50);
    
    $(this).css({
        paddingTop: random + '%',
        paddingBottom: (80-random) + '%'
    });
    
});

/***** IMAGES OPACITY *****/ 

    // var validEmailRE = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    // $('.mm-contact-form .mm-send-button').on('click', function(){
    //     var $this = $(this);
    //     var email = $this.prev().val();
        
    //     if(!email || !validEmailRE.test(email)) {
    //         $('.mm-invalid-email-message', $this.closest('form')).addClass('mm-visible');
    //         $('.mm-form-sent-message', $this.closest('form')).removeClass('mm-visible');
    //     } else {
    //         $('.mm-invalid-email-message', $this.closest('form')).removeClass('mm-visible');
			
    //         $('.mm-form-sent-message', $this.closest('form')).addClass('mm-visible');
    //     }
        
    //     return false;
    // });

    $(document).on( 'wpcf7mailsent', function() {
      console.log('gtag event');
      gtag('event', 'formularz');
    });


  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
	
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js